import './layout.css';
import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import Aside from '../aside/Aside';
import Footer from '../footer/Footer';
import Header from '../header/Header';
import ReactFocusLock from 'react-focus-lock';

const Layout = ({
    listaMenu,
    titulo,
    children,
    onKeyDown
}) => {

    const pathLocation = useLocation();

    const [menu, setMenu] = useState({
        larguraDoMenu: '66px',
        exibirEmpresa: 'none',
        exibirTexto: 'none',
        validarMenu: false
    });

    const abrirEFecharMenu = () => {
        if (!menu.validarMenu) {
            setMenu(menu => ({
                ...menu,
                larguraDoMenu: '300px',
                exibirEmpresa: 'flex',
                exibirTexto: 'flex',
                validarMenu: true
            }));
        } else {
            setMenu(menu => ({
                ...menu,
                larguraDoMenu: '66px',
                exibirEmpresa: 'none',
                exibirTexto: 'none',
                validarMenu: false
            }));
        };
    };

    useEffect(() => {
        setMenu(menu => ({
            ...menu,
            larguraDoMenu: '66px',
            exibirEmpresa: 'none',
            exibirTexto: 'none',
            validarMenu: false
        }));
    }, [pathLocation]);

    return (
        <ReactFocusLock>
            <div className='template' onKeyDown={onKeyDown}>
                <Aside
                    listaMenu={listaMenu}
                    larguraDoMenu={menu.larguraDoMenu}
                    visibilidadeDoMenu={menu.exibirEmpresa}
                    exibirEOcultarTexto={menu.exibirTexto}
                    click={abrirEFecharMenu}
                />
                <Header
                    titulo={titulo}
                />
                <main className='main'>
                    {children}
                </main>
                <Footer />
            </div>
        </ReactFocusLock>
    );
};

export default Layout;